import styled from 'styled-components'
import { AlignType, MarginType } from 'common/types/styleTypes'
import {
  textCss,
  mobileTextCss,
  marginCss,
  mobileMarginCss,
} from 'common/utils/styleUtilsNew'

type BlogPostCategoriesNewUiProps = {
  fontSize: number
  color: string
  fontFamily?: string
  fontWeight?: string
  fontStyle?: string
  textAlign: AlignType
  mobileColor?: string
  mobileFontSize?: number
  mobileFontFamily?: string
  mobileFontWeight?: string
  mobileFontStyle?: string
  mobileTextAlign?: AlignType
  mobileFontFilePath?: string
  margin?: Partial<MarginType>
  mobileMargin?: Partial<MarginType>
}

const BlogPostCategoriesNewUi = styled.div<BlogPostCategoriesNewUiProps>`
  ${textCss};
  ${marginCss}
  ${p => p.theme.isEditorMobileMode && mobileTextCss}
  ${p => p.theme.isEditorMobileMode && mobileMarginCss}
  ${p => p.theme.phone} {
    ${mobileMarginCss}
    ${mobileTextCss}
  }
`

export default BlogPostCategoriesNewUi
